import React, {Component} from "react";
import PropTypes from "prop-types";
import {Card} from "react-bootstrap";
import "../Elements/FromGroup/form_select.css"
import AscModal from "../Elements/Modal/Modal";
import {ViewCategoryName, ViewPromptText} from "../Elements/AscElements/VocCategoryElements";

export default class VocCategoryReadModal extends Component {
    render() {
        return (
            <AscModal
                state={this.props.state}
                propSetState={this.props.propSetState}
                langText={this.props.langText}
                validationHandle={this.props.validationHandle}
                onClick={this.props.onClick}
                readOnly={true}>
                <Card variant="info">
                    <Card.Header>
                        <Card.Title>
                            {this.props.langText.Body.VocCategoryInfo}
                        </Card.Title>
                    </Card.Header>

                    <Card.Body>
                        <ViewCategoryName
                            state={this.props.state}
                            langText={this.props.langText}
                        />
                        <ViewPromptText
                            state={this.props.state}
                            langText={this.props.langText}
                        />
                    </Card.Body>
                </Card>
            </AscModal>
        );
    }
}

VocCategoryReadModal.propTypes = {
    state: PropTypes.object.isRequired,
    langText: PropTypes.object.isRequired,
    onClick: PropTypes.func.isRequired,
    validationHandle: PropTypes.func.isRequired,
    propSetState: PropTypes.func,
};
